/**
 * Picks v2 or v1 of the Attribution Options page based on the
 * redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AttributionOptionsPage   from './AttributionOptionsPage';
import AttributionOptionsPageV2 from './v2/AttributionOptionsPageV2';

export default function AttributionOptionsPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AttributionOptionsPageV2 : AttributionOptionsPage;
  return <Component {...props} />;
}
